export default __webpack_public_path__ + "static/media/wd-main-picture.43d99e1c.png";